/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Documents_ChangedInputs */

const en_checkout_documents_changed = /** @type {(inputs: Checkout_Documents_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The booking terms, cancellation policy, or house rules have been updated since this page loaded. Please review them again and re-check the box to continue.`)
};

/**
* | output |
* | --- |
* | "The booking terms, cancellation policy, or house rules have been updated since this page loaded. Please review them again and re-check the box to continue." |
*
* @param {Checkout_Documents_ChangedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_documents_changed = /** @type {((inputs?: Checkout_Documents_ChangedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Documents_ChangedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_documents_changed(inputs)
});